import { render, staticRenderFns } from "./PatientDetailConsultations.vue?vue&type=template&id=bff477de&scoped=true"
import script from "./PatientDetailConsultations.vue?vue&type=script&lang=js"
export * from "./PatientDetailConsultations.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailConsultations.vue?vue&type=style&index=0&id=bff477de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff477de",
  null
  
)

export default component.exports